import { actionTypes } from "./actions";

const initialState = {
  ezds: [],
  mcds: [],
  ezdIngestions: [],
  mcdIngestions: [],
  ingestionDetails: [],
  rollbackPopupOpen: false,
  rollbackLoader: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_EZDS:
      return {
        ...state,
        ezds: payload,
      };
    case actionTypes.SET_MCDS:
      return {
        ...state,
        mcds: payload,
      };
    case actionTypes.SET_EZD_ROLLBACK_INGESTIONS:
      return {
        ...state,
        ezdIngestions: payload,
      };
    case actionTypes.SET_MCD_ROLLBACK_INGESTIONS:
      return {
        ...state,
        mcdIngestions: payload,
      };
    case actionTypes.SET_INGESTION_DETAILS:
      return {
        ...state,
        ingestionDetails: payload
      }
    case actionTypes.ROLLBACK_POPUP_OPEN:
      return {
        ...state,
        rollbackPopupOpen: payload
      }
    case actionTypes.ROLLBACK_LOADER:
      return {
        ...state,
        rollbackLoader: payload
      }
    default:
      return {
        ...state,
      };
  }
};
